import JoineryDimension from "./JoineryDimension";

export default JoineryDimension;